import { html } from 'lit';
import { ArrowUp } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-arrow-up')
export class PdsIconArrowUp extends PdsIcon {
  @state()
  icon = ArrowUp;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
